<div class="container">
  <mic-breadcrumb id="casing-grade-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('casingGradeText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title" id="casing-grade-heading">{{ translationService.translate('casingGradeText') }}</h2>

  <mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="isLoading">
    <div class="action-bar">
      <button id="reset-filters" class="btn-clear" type="button" mat-flat-button color="accent" (click)="resetFilters()">
        <mat-icon>refresh</mat-icon>
        {{ translationService.translate('clearSelectionText') }}
      </button>
      <span
        [matTooltip]="
          !this.canEditCasingGrade
            ? this.translationService.translate('userCannotSaveText')
            : productSaveDisabled
            ? this.translationService.translate('comingSoonText')
            : !isSaveEnabled
            ? this.translationService.translate('noModifiedText')
            : null
        "
      >
        <button
          id="save"
          class="btn-primary"
          type="button"
          mat-flat-button
          color="primary"
          (click)="save()"
          [disabled]="!isSaveEnabled || !this.canEditCasingGrade"
        >
          <mat-icon>save</mat-icon>
          {{ translationService.translate('saveLinkText') }}
        </button>
      </span>
      <button
        id="add-grade"
        class="btn-primary"
        type="button"
        mat-flat-button
        color="primary"
        (click)="addRow()"
        [disabled]="!this.canEditCasingGrade"
        [matTooltip]="productSaveDisabled ? this.translationService.translate('comingSoonText') : null"
      >
        <mat-icon>add</mat-icon>
        {{ translationService.translate('addGradeText') }}
      </button>
    </div>

    <mat-card class="search-card mt-3">
      <form [formGroup]="filterForm">
        <div class="grid-container">
          <app-dropdown-search-single-select
            id="gradeDropdown"
            label="{{ translationService.translate('casingGradeText') }}"
            emptyPlaceholder="{{ translationService.translate('selectGradeText') }}"
            placeholder="{{ translationService.translate('selectGradeText') }}"
            [formGroup]="filterForm"
            formControlName="grades"
            [data]="gradeFilterList"
          >
          </app-dropdown-search-single-select>
          <app-dropdown-search-single-select
            id="descDropdown"
            label="{{ translationService.translate('descriptionText') }}"
            emptyPlaceholder="{{ translationService.translate('selectDescText') }}"
            placeholder="{{ translationService.translate('selectDescText') }}"
            [formGroup]="filterForm"
            formControlName="descriptions"
            [data]="descriptionFilterList"
          >
          </app-dropdown-search-single-select>
        </div>
      </form>
    </mat-card>

    <div id="casing-grade-table" class="cam-table table-container">
      <mic-table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'grade'">
          <input type="text" matInput maxlength="4" [formControl]="getControl(item, 'casingGrade')" />
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'description'">
          <input type="text" matInput maxlength="20" [formControl]="getControl(item, 'casingDescription')" />
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'rank'">
          <input matInput type="text" maxlength="2" [formControl]="getControl(item, 'rank')" />
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'action'">
          <span
            [matTooltip]="
              !canEditCasingGrade || !canBeDeleted(item)
                ? translationService.translate('canNotDeleteBecauseText') + ' ' + translationService.translate('itemIsInUseText')
                : ''
            "
            matTooltipPosition="below"
          >
            <button mat-icon-button [disabled]="!canEditCasingGrade || !canBeDeleted(item)" (click)="showDeleteModal(item)">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </span>
        </ng-container>
      </mic-table>
    </div>
  </mic-spinner-overlay>
  <mic-modal class="modalC" #deleteConfirmation (result)="onDeleteModalClosed($event)"></mic-modal>
  <ng-template #deleteContent>Are you sure you want to delete the Casing Grade?</ng-template>
  <mic-modal class="modalC" #discardConfirmation (result)="onDiscardModalClosed($event)"></mic-modal>
  <ng-template #discardContent>{{ translationService.translate('unSaveChangesText') }}</ng-template>
</div>
